/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-08-26 09:57:17
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-08-27 11:13:22
 */
import React, {Component} from 'react'
import './Newspart.css'
import moment from 'moment'
// import pic from '../../Pic/图层 4.png'
// import icon_delete from '../../Pic/icon-delete.png'
// import icon_edit from '../../Pic/icon-edit.png'
import tag_hot from '../../Pic/tag-hot.png'
// import icon_edit_checked from '../../Pic/icon-edit-选中.png'
// import icon_delete_checked from '../../Pic/icon-delete-选中.png'
import {Link} from 'react-router-dom';
// import Axios from 'axios';
// import NewsDetail from '../../NewsDetail'
import {deleteNews} from '../../service/action'

const momentFormat = "YYYY-MM-DD"
export default class Newspart extends Component {

    render() {
        let {data, newsTag, newsText} = this.props;

        // console.log(data.viewCount);
        // let newsTag = this.props.newsTag   
        return (
            // 单独列表模块
            <div id='moduleNews'>
                <div className="news_card">
                    <img className='new_pic' src={data.thumbnail} alt=''></img>
                    <div className={newsTag}>{newsText}</div>

                    <img className='news_tag_hot' src={tag_hot} alt=''
                         style={{display: data.viewCount >= 50 ? 'block' : 'none'}}></img>

                    <div className='news-text-part'>

                        <div className="title_container">
                            <div className='title-news'>
                                <Link className='title-news-link' to={`/NewsBulletin/NewsDetail/${data.id}`}>
                                    {data.title}
                                </Link>
                            </div>
                            <p className='time-news'>{moment(data.created).format(momentFormat)}</p>
                        </div>

                        <p className='content-news'>{data.summary}</p>
                        {data.source == '1' ?
                            // <div className="new-author">编者：{data.author}</div>
                            // <div className="new-author">新闻来源：{data.source}</div>
                            <div className="new-author">新闻来源：{"转载"}</div>
                            : null}
                    </div>
                    {/* <div className='edit-news'>
                        <div className={'icon_edit'} onClick={this.props.jump2Editor.bind(this,data) }></div>
                        <div className={'icon_delete'} onClick={async () => {
                            await deleteNews(data.id)
                            window.location.reload()
                        }}></div>
                    </div> */}
                </div>
            </div>
        )
    }
}
